var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportFileCartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29308_168367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00888 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87898 15.1541 3.84551 13.6543 2.34572C12.1545 0.845932 10.121 0.00232928 8 0ZM10.9648 10.176L8.5648 12.576C8.41478 12.726 8.21133 12.8102 7.9992 12.8102C7.78707 12.8102 7.58362 12.726 7.4336 12.576L5.0336 10.176C4.88788 10.0251 4.80724 9.82304 4.80906 9.61328C4.81089 9.40352 4.89502 9.20287 5.04335 9.05455C5.19167 8.90622 5.39232 8.82208 5.60208 8.82026C5.81184 8.81844 6.01392 8.89907 6.1648 9.0448L7.2 10.08V4.0072C7.2 3.79503 7.28429 3.59154 7.43432 3.44152C7.58435 3.29149 7.78783 3.2072 8 3.2072C8.21218 3.2072 8.41566 3.29149 8.56569 3.44152C8.71572 3.59154 8.8 3.79503 8.8 4.0072V10.08L9.8344 9.0456C9.9863 8.9058 10.1864 8.83013 10.3927 8.8344C10.5991 8.83868 10.7959 8.92257 10.9419 9.06855C11.0878 9.21452 11.1717 9.41127 11.176 9.61766C11.1803 9.82405 11.1046 10.0241 10.9648 10.176Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29308_168367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFileCartIcon);
export default __webpack_public_path__ + "static/media/export-file-cart-icon.0c7871bfa7b76a7ebc3ef3115d0610dd.svg";
export { ForwardRef as ReactComponent };